export const SEARCH_ORGS_REFINEMENT_TYPES = [
  'areasOfFocus',
  'locale',
  'orgType',
  'radius',
] as const;

export type SearchOrgsRefinementType =
  (typeof SEARCH_ORGS_REFINEMENT_TYPES)[number];
